import PropTypes from 'prop-types';
import React from 'react';
import CardGrid, { FooterDivider, FooterText, formatCount } from './common/grid/CardGrid';
import FitItemGrid from './FitItemGrid';

export default function ItemCardGrid(props) {
  const {
    currentPage,
    itemActions,
    listActions,
  } = props;

  const { handleNextPage, handlePreviousPage } = listActions;

  const {
    pagesCount, pageNumber, items, namespace, stats,
  } = currentPage || {};

  const { timeNeeded, timeSpent, totalItems } = stats || {};
  const countLabel = formatCount(totalItems, 'item', 'items');
  const timeNeededMinutes = timeNeeded && timeNeeded.toLocaleString('en-US');
  const timeNeededHours = timeNeeded && Math.round(timeNeeded / 60).toLocaleString('en-US');
  let percent = (timeSpent != null && timeNeeded > 0) ? (100 * (timeSpent / timeNeeded)) : null;
  if (percent != null && percent !== 100) percent = percent.toFixed(1);
  const timeSpentMinutes = timeSpent && timeSpent.toLocaleString('en-US');

  const showTime = timeNeeded > 0;
  const showPercent = percent != null && percent > 0;

  const counter = (countLabel || showTime || showPercent) ? (
    <>
      {countLabel && <FooterText>{countLabel}</FooterText>}
      {countLabel && showTime && (
        <FooterDivider sx={{ display: { xs: 'none', sm: 'block' } }}>|</FooterDivider>
      )}
      {showTime && (
        <FooterText
          sx={{ color: 'primary.main', display: { xs: 'none', sm: 'block' } }}
          title={`${timeNeededMinutes} minutes`}
        >
          {timeNeeded > 60 ? `${timeNeededHours} hours` : `${timeNeededMinutes} minutes`}
        </FooterText>
      )}
      {showTime && showPercent && (
        <FooterDivider sx={{ display: { xs: 'none', md: 'block' } }}>|</FooterDivider>
      )}
      {showPercent && (
        <FooterText
          sx={{ color: 'success.main', display: { xs: 'none', md: 'block' } }}
          title={`${timeSpentMinutes} minutes`}
        >
          {`${percent}% learned`}
        </FooterText>
      )}
    </>
  ) : null;

  return (
    <CardGrid
      hasContent={Boolean(items && items.length > 0)}
      pageNumber={pageNumber}
      pagesCount={pagesCount}
      onNextPage={handleNextPage}
      onPreviousPage={handlePreviousPage}
      counter={counter}
    >
      <FitItemGrid
        items={items}
        namespace={namespace}
        itemActions={itemActions}
      />
    </CardGrid>
  );
}

ItemCardGrid.propTypes = {
  currentPage: PropTypes.object.isRequired,
  itemActions: PropTypes.object.isRequired,
  listActions: PropTypes.object.isRequired,
};
